import { useState, useEffect, useCallback } from "react";
import EventEmitter from "events";
import { Services } from "@/types/serviceTypes";

const eventBus = new EventEmitter();

export function useSharedServices(
  initialState: Services,
): [
  Services,
  (update: Services | ((prevState: Services) => Services)) => void,
] {
  const [services, setServices] = useState(initialState);

  useEffect(() => {
    const handleUpdate = (
      update: Services | ((prevState: Services) => Services),
    ) => {
      if (typeof update === "function") {
        setServices((prevState) => update(prevState));
      } else {
        setServices(update);
      }
    };

    eventBus.on("updateServices", handleUpdate);

    return () => {
      eventBus.removeListener("updateServices", handleUpdate);
    };
  }, []);

  const updateServices = useCallback(
    (update: Services | ((prevState: Services) => Services)) => {
      eventBus.emit("updateServices", update);
    },
    [],
  );

  return [services, updateServices];
}
